// Comprehensive list of Indian cities including Tier 1, 2, 3, 4 cities and major towns
export const indianCities = [
  // Tier 1 Cities (Metro Cities)
  'Mumbai', 'Delhi', 'Bangalore', 'Hyderabad', 'Ahmedabad', 'Chennai', 'Kolkata', 'Pune',
  
  // Tier 2 Cities (Major Cities)
  'Surat', 'Jaipur', 'Lucknow', 'Kanpur', 'Nagpur', 'Indore', 'Thane', 'Bhopal',
  'Visakhapatnam', 'Pimpri-Chinchwad', 'Patna', 'Vadodara', 'Ghaziabad', 'Ludhiana',
  'Agra', 'Nashik', 'Faridabad', 'Meerut', 'Rajkot', 'Kalyan-Dombivali', 'Vasai-Virar',
  'Varanasi', 'Srinagar', 'Aurangabad', 'Dhanbad', 'Amritsar', 'Navi Mumbai', 'Allahabad',
  'Ranchi', 'Howrah', 'Coimbatore', 'Jabalpur', 'Gwalior', 'Vijayawada', 'Jodhpur',
  'Madurai', 'Raipur', 'Kota', 'Chandigarh', 'Guwahati', 'Solapur', 'Hubli-Dharwad',
  'Mysore', 'Tiruchirappalli', 'Bareilly', 'Aligarh', 'Tiruppur', 'Moradabad', 'Jalandhar',
  'Bhubaneswar', 'Salem', 'Warangal', 'Guntur', 'Bhiwandi', 'Saharanpur', 'Gorakhpur',
  'Bikaner', 'Amravati', 'Noida', 'Jamshedpur', 'Bhilai', 'Cuttack', 'Firozabad',
  'Kochi', 'Nellore', 'Bhavnagar', 'Dehradun', 'Durgapur', 'Asansol', 'Rourkela',
  'Nanded', 'Kolhapur', 'Ajmer', 'Akola', 'Gulbarga', 'Jamnagar', 'Ujjain', 'Loni',
  'Siliguri', 'Jhansi', 'Ulhasnagar', 'Jammu', 'Sangli-Miraj', 'Mangalore', 'Erode',
  'Belgaum', 'Ambattur', 'Tirunelveli', 'Malegaon', 'Gaya', 'Jalgaon', 'Udaipur',
  'Maheshtala',
  
  // Tier 3 Cities
  'Thiruvananthapuram', 'Kozhikode', 'Thrissur', 'Malappuram', 'Kollam', 'Kannur',
  'Alappuzha', 'Palakkad', 'Kottayam', 'Trichur', 'Shimoga', 'Davangere', 'Bellary',
  'Bijapur', 'Raichur', 'Tumkur', 'Bidar', 'Hospet', 'Gadag-Betageri', 'Robertsonpet',
  'Hassan', 'Mandya', 'Chikmagalur', 'Udupi', 'Karwar', 'Rajahmundry', 'Kakinada',
  'Eluru', 'Ongole', 'Nandyal', 'Kurnool', 'Kadapa', 'Tirupati', 'Anantapur', 'Vizianagaram',
  'Karimnagar', 'Nizamabad', 'Khammam', 'Mahbubnagar', 'Suryapet', 'Siddipet', 'Adilabad',
  'Miryalaguda', 'Sangareddy', 'Vellore', 'Kanchipuram', 'Thoothukudi', 'Dindigul',
  'Thanjavur', 'Ranipet', 'Sivakasi', 'Karur', 'Udhagamandalam', 'Hosur', 'Nagercoil',
  'Pollachi', 'Rajapalayam', 'Gudiyatham', 'Pudukkottai', 'Vaniyambadi', 'Ambur',
  'Cuddalore', 'Kumbakonam', 'Avadi', 'Pallavaram', 'Jamalpur', 'Muzaffarpur',
  'Bhagalpur', 'Darbhanga', 'Purnia', 'Katihar', 'Munger', 'Chhapra', 'Sasaram',
  'Hajipur', 'Dehri', 'Bettiah', 'Motihari', 'Begusarai', 'Saharsa', 'Sasaram',
  'Rohtak', 'Panipat', 'Karnal', 'Sonipat', 'Yamunanagar', 'Panchkula', 'Bhiwani',
  'Sirsa', 'Bahadurgarh', 'Jind', 'Thanesar', 'Kaithal', 'Rewari', 'Palwal', 'Hisar',
  'Ambala', 'Shimla', 'Solan', 'Mandi', 'Palampur', 'Kullu', 'Dharamshala', 'Hamirpur',
  'Una', 'Nahan', 'Jammu', 'Udhampur', 'Anantnag', 'Baramulla', 'Sopore', 'Kathua',
  'Samba', 'Leh', 'Ratlam', 'Mandsaur', 'Satna', 'Murwara', 'Singrauli', 'Rewa',
  'Katni', 'Damoh', 'Sagar', 'Burhanpur', 'Khandwa', 'Bhind', 'Chhindwara', 'Guna',
  'Shivpuri', 'Vidisha', 'Chhatarpur', 'Damoh', 'Mandsaur', 'Khargone', 'Neemuch',
  'Pithampur', 'Narmadapuram', 'Itarsi', 'Sehore', 'Betul', 'Seoni', 'Datia', 'Nagda',
  'Silvassa', 'Daman', 'Diu', 'Kavaratti', 'Port Blair', 'Puducherry', 'Karaikal',
  'Yanam', 'Mahe', 'Gandhidham', 'Anand', 'Nadiad', 'Morbi', 'Surendranagar', 'Bharuch',
  'Vapi', 'Navsari', 'Veraval', 'Porbandar', 'Godhra', 'Botad', 'Amreli', 'Deesa',
  'Jetpur', 'Junagadh', 'Gandhinagar', 'Mehsana', 'Palanpur', 'Patan', 'Bhuj',
  'Gandhidham', 'Mandvi', 'Dhanbad', 'Giridih', 'Bokaro', 'Deoghar', 'Phusro', 'Hazaribagh',
  'Ramgarh', 'Medininagar', 'Chirkunda', 'Panipat', 'Ambala', 'Hoshiarpur', 'Batala',
  'Pathankot', 'Moga', 'Abohar', 'Malerkotla', 'Khanna', 'Phagwara', 'Muktsar',
  'Barnala', 'Rajpura', 'Firozpur', 'Kapurthala', 'Zirakpur', 'Kotkapura', 'Mansa',
  'Gobindgarh', 'Khanna', 'Morinda', 'Fazilka', 'Sambalpur', 'Raurkela', 'Brahmapur',
  'Puri', 'Balasore', 'Baripada', 'Bhadrak', 'Balangir', 'Jharsuguda', 'Jeypore',
  'Udaipur', 'Bargarh', 'Paradip', 'Bhawanipatna', 'Rayagada', 'Jaipur', 'Kota',
  'Bikaner', 'Ajmer', 'Udaipur', 'Bhilwara', 'Alwar', 'Bharatpur', 'Pali', 'Tonk',
  'Sikar', 'Kishangarh', 'Beawar', 'Hanumangarh', 'Gangapur City', 'Churu', 'Jhunjhunu',
  'Sri Ganganagar', 'Sawai Madhopur', 'Baran', 'Bundi', 'Chittorgarh', 'Nathdwara',
  'Mount Abu', 'Ankleshwar', 'Valsad', 'Palghar', 'Dahanu', 'Alibag', 'Panvel',
  'Karjat', 'Khopoli', 'Pen', 'Uran', 'Ratnagiri', 'Sindhudurg', 'Chiplun', 'Kudal',
  'Sawantwadi', 'Vengurla',
  
  // Tier 4 Cities and Towns (Sample)
  'Samastipur', 'Sitamarhi', 'Sheohar', 'Madhubani', 'Siwan', 'Gopalganj', 'Kishanganj',
  'Araria', 'Supaul', 'Madhepura', 'Sheikhpura', 'Nawada', 'Lakhisarai', 'Jamui',
  'Banka', 'Khagaria', 'Arwal', 'Jehanabad', 'Aurangabad', 'Gaya', 'Narnaul', 'Fatehabad',
  'Tohana', 'Ratia', 'Ellenabad', 'Pehowa', 'Gohana', 'Meham', 'Narnaul', 'Hansi',
  'Barwala', 'Charkhi Dadri', 'Bhiwani', 'Farukhnagar', 'Ballabhgarh', 'Hodal',
  'Kosli', 'Nuh', 'Ferozepur Jhirka', 'Taoru', 'Hathin', 'Sohna', 'Bilaspur', 'Ambala Cantt',
  'Jagadhri', 'Ladwa', 'Gharaunda', 'Shahabad Markanda', 'Pinjore', 'Kalka', 'Naraingarh',
  'Raikot', 'Sunam', 'Jagraon', 'Dharamkot', 'Sardulgarh', 'Budhlada', 'Dirba',
  'Payal', 'Talwandi Sabo', 'Rampura Phul', 'Gidderbaha', 'Kharar', 'Dera Bassi',
  'Mohali', 'Banur', 'Lalru', 'Kurali', 'Nangal', 'Anandpur Sahib', 'Garhshankar',
  'Banga', 'Nawanshahr', 'Balachaur', 'Bilaspur', 'Hamirpur', 'Sarkaghat', 'Sundernagar',
  'Jogindernagar', 'Pandoh', 'Arki', 'Nalagarh', 'Baddi', 'Mehatpur', 'Gagret',
  'Haroli', 'Amb', 'Bangana', 'Chintpurni', 'Daulatpur', 'Nadaun', 'Jaisinghpur',
  'Dehra Gopipur', 'Palampur', 'Baijnath', 'Nurpur', 'Shahpur', 'Kangra', 'Bhuntar',
  'Manali', 'Banjar', 'Rampur', 'Narkanda', 'Theog', 'Kotkhai', 'Rohru', 'Jubbal',
  'Karsog', 'Chowari', 'Dharmsala', 'Paonta Sahib', 'Rajgarh', 'Pachhad', 'Renukaji',
  'Shillai', 'Sangrah', 'Arki', 'Bilaspur', 'Dalhousie', 'Chamba', 'Bharmaur',
  'Tissa', 'Holi', 'Pangi', 'Udaipur', 'Rewalsar', 'Kataula', 'Paddal', 'Thunag',
  'Chachiot', 'Lahaul', 'Keylong', 'Udaipur', 'Tandi', 'Kaza', 'Pooh', 'Kalpa',
  'Reckong Peo', 'Nichar', 'Sangla', 'Moorang', 'Chitkul'
].sort();

